// @greenlight-spec: 28-it-dashboard-ui.md
// @greenlight-spec: 19-design-system.md
import * as React from 'react';

export interface SettingsSectionHeadingProps {
  title: string;
  /** Audience pill, e.g. "Org admin", "IT", "Everyone". Omit to render no pill. */
  pill?: string;
}

// Shared heading for every Settings section: title + audience pill.
export function SettingsSectionHeading({
  title,
  pill,
}: SettingsSectionHeadingProps): React.JSX.Element {
  return (
    <div className="flex items-center gap-2.5">
      <h2 className="text-xl font-semibold tracking-[-0.02em]">{title}</h2>
      {pill !== undefined && (
        <span className="rounded-gl bg-muted px-2 py-0.5 font-mono text-[10px] uppercase tracking-wide text-foreground whitespace-nowrap">
          {pill}
        </span>
      )}
    </div>
  );
}
